import type { SVGProps } from "react";

type BrandLogoMarkProps = SVGProps<SVGSVGElement> & {
  size?: number;
  variant?: "mono" | "accent" | "white";
};

export function BrandLogoMark({ size = 24, variant = "accent", ...rest }: BrandLogoMarkProps) {
  const fill =
    variant === "mono"
      ? "var(--brand-ink)"
      : variant === "white"
        ? "#FFFFFF"
        : "url(#vaon-bolt-grad)";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      {variant === "accent" && (
        <defs>
          <linearGradient id="vaon-bolt-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FFA04A" />
            <stop offset="100%" stopColor="#FF4E2E" />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17 4 L9 17 L14 17 L12 28 L23 14 L18 14 L20 4 Z"
        fill={fill}
      />
    </svg>
  );
}
